import { useEffect, useRef } from 'react';

const FOOTER_LEGALS = [
    { label: 'Impressum', href: 'https://www.swisscom.ch/de/privatkunden/impressum.html' },
    { label: 'Rechtliches', href: 'https://www.swisscom.ch/de/privatkunden/rechtliches.html' },
    { label: 'Kontakt', href: 'https://www.swisscom.ch/de/privatkunden/hilfe.html' },
    { label: 'Datenschutz', href: 'https://www.swisscom.ch/de/privatkunden/rechtliches/datenschutz.html' },
];

export default function AppFooter() {
    const footerRef = useRef(null);

    useEffect(() => {
        const footer = footerRef.current;

        if (!footer) {
            return undefined;
        }

        const applyFooterStyles = () => {
            const root = footer.shadowRoot;

            if (!root || root.querySelector('[data-greenone-footer-styles]')) {
                return;
            }

            const style = document.createElement('style');
            style.setAttribute('data-greenone-footer-styles', 'true');
            style.textContent = `
                :host {
                    display: block;
                    width: 100%;
                    text-align: center;
                }

                .footer,
                .legals,
                .links,
                [part="footer"],
                [part="links"],
                [part="legals"],
                slot {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    flex-wrap: wrap;
                    width: 100%;
                }

                ::slotted(*) {
                    text-align: center;
                }
            `;

            root.appendChild(style);
        };

        applyFooterStyles();

        const handleLanguageSelect = event => {
            alert(`Selected language ${event.detail.item.label}`);
        };

        footer.addEventListener('language-select', handleLanguageSelect);

        return () => {
            footer.removeEventListener('language-select', handleLanguageSelect);
        };
    }, []);

    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
            <sdx-footer
                ref={footerRef}
                style={{ width: '100%', textAlign: 'center' }}
                legals={JSON.stringify(FOOTER_LEGALS)}
                languages='[
}
]'
            ></sdx-footer>
        </div>
    );
}
